import { Panel } from 'primereact/panel'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ImportRtfFile, Loading, PageHeader, TextBtn } from '../../../../components'
import * as ImportacaoHttp from '../../../../services/api/https/deliveries/importation.http'
import { errorHandler } from '../../../../services/util/error.service'
import { showMessageBox } from '../../../../store/actions/system.actions'
import CardsResultadoImportacao from '../ImportacaoCicloEntrega/CardsResultadoImportacao'
import TabsClientesEhProdutosNaoCadastrados from '../ImportacaoCicloEntrega/TabsClientesEhProdutosNaoCadastrados'

const ShowMode = {
  MESSAGE: 'MESSAGE',
  LOADING: 'LOADING',
  CARDS: 'CARDS',
  TABS: 'TABS',
}
function ImportacaoCicloEntregaRtf({ history, dispatch, selectedCiclo }) {
  // Vars
  const { cicloId, file_type_id } = selectedCiclo

  // Hooks
  const [showMode, setShowMode] = useState(ShowMode.LOADING)
  const [result, setResult] = useState({
    qteDeliveries: '',
    qteIdentifiers: '',
    qteSkus: '',
    weight: '',
  })
  const [produtosSemCadastros, setProdutosSemCadastros] = useState([])
  const [produtosComInconsistencia, setProdutosComInconsistencia] = useState([])
  const [clientesSemCadastros, setClientesSemCadastros] = useState([])

  useEffect(() => {
    async function fetchCicloInfo() {
      try {
        const { qteDeliveries, qteIdentifiers, qteSkus, weight } =
          await ImportacaoHttp.getCicloInfo(cicloId)
        if (qteDeliveries) {
          setShowMode(ShowMode.CARDS)
          setResult({ qteDeliveries, qteIdentifiers, qteSkus, weight })
        } else {
          setShowMode(ShowMode.MESSAGE)
        }
      } catch (error) {
        dispatch(showMessageBox(null, error, true))
        setShowMode(ShowMode.MESSAGE)
      }
    }
    cicloId && !Number.isNaN(cicloId) && fetchCicloInfo()
  }, [cicloId])

  // Events
  const onError = error => {
    dispatch(showMessageBox(null, errorHandler(error)), true)
  }

  const onRtfImportationSuccess = async data => {
    try {
      setShowMode(ShowMode.LOADING)
      const { qteDeliveries, qteIdentifiers, qteSkus, weight } =
        await ImportacaoHttp.importDeliveries(cicloId, data, file_type_id)
      dispatch(showMessageBox('Importação realizada com sucesso', null))
      setShowMode(ShowMode.CARDS)
      setResult({ qteDeliveries, qteIdentifiers, qteSkus, weight })
    } catch (error) {
      const {
        message,
        clientsNotSaved = [],
        productsNotSaved = [],
        productsWithInconsistency = [],
      } = error
      if (message) {
        dispatch(showMessageBox(null, message, true))
        if (
          clientsNotSaved.length > 0 ||
          productsNotSaved.length > 0 ||
          productsWithInconsistency.length > 0
        ) {
          setProdutosSemCadastros(productsNotSaved)
          setProdutosComInconsistencia(productsWithInconsistency)
          setClientesSemCadastros(clientsNotSaved)
          setShowMode(ShowMode.TABS)
        }
      } else {
        setShowMode(ShowMode.MESSAGE)
        dispatch(showMessageBox(null, error, true))
      }
    }
  }

  // Helpers

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Importação&nbsp;<strong>RTF</strong>&nbsp;-&nbsp;Ciclos de Entrega&nbsp;-&nbsp;
        <strong>{selectedCiclo.cicloName}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel
          header={
            <ImportacaoPanelHeader
              onSuccess={onRtfImportationSuccess}
              onError={onError}
              onVoltar={history.goBack}
              isLoading={showMode === ShowMode.LOADING}
            />
          }
        >
          {showMode === ShowMode.MESSAGE ? (
            <div style={{ textAlign: 'center', color: '#c4c4c4' }}>
              Para realizar a importação, clique no botão Importar
            </div>
          ) : null}
          {showMode === ShowMode.CARDS ? (
            <CardsResultadoImportacao
              weight={result.weight}
              qteSkus={result.qteSkus}
              qteIdentifiers={result.qteIdentifiers}
              qteDeliveries={result.qteDeliveries}
            />
          ) : null}
          {showMode === ShowMode.TABS ? (
            <TabsClientesEhProdutosNaoCadastrados
              produtosSemCadastros={produtosSemCadastros}
              clientesSemCadastros={clientesSemCadastros}
              produtosComInconsistencia={produtosComInconsistencia}
            />
          ) : null}
          {showMode === ShowMode.LOADING ? <Loading /> : null}
        </Panel>
      </div>
    </React.Fragment>
  )
}

function ImportacaoPanelHeader({ isLoading, onError, onSuccess, onVoltar }) {
  // Render
  return (
    <div className="p-grid">
      <div className="p-col-3">
        <div style={{ display: 'inline-block', position: 'relative', width: 80, height: 20 }}>
          <div
            className="text-center"
            style={{
              visibility: !isLoading ? 'visible' : 'hidden',
              position: 'absolute',
            }}
          >
            <ImportRtfFile onError={onError} onSuccess={onSuccess} />
          </div>
          <div
            className="text-center"
            style={{
              visibility: isLoading ? 'visible' : 'hidden',
              position: 'absolute',
            }}
          >
            <Loading />
          </div>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <TextBtn onClick={onVoltar}>Voltar</TextBtn>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ ciclo_entrega: { selectedCiclo } }) => ({ selectedCiclo })
export default connect(mapStateToProps)(withRouter(ImportacaoCicloEntregaRtf))
